import type { ISts } from '@dakedake/types'
import { stsInit } from '@/services'
import { useCallback, useState } from 'react'

export default function useCos() {
  const [sts, setSts] = useState<ISts>()

  const getSts = useCallback(async () => {
    const res = await stsInit()
    setSts(res.data)
  }, [])

  return {
    sts,
    getSts
  }
}
